
export type NotificationSettingsTypeSettings = {[key: string]: boolean};
